import { Entities } from '../../entityDalFactory';
import { GridConstants } from './grid.constants';

export const praticheActionType = GridConstants(Entities.PraticaEno);
